import Devices from '../../../components/blocks/devices';
import ScansDaytime from '../../../components/blocks/scansDaytime';
import ScansLocation from '../../../components/blocks/scansLocation';
import TotalScans from '../../../components/blocks/totalScans';
import TotalUsersChart from '../../../components/blocks/totalUsersChart';
import UniqueUsers from '../../../components/blocks/uniqueUsers';
import UniqueUsersChart from '../../../components/blocks/uniqueUsersChart';
import { PAGE_STATISTICS_TAB } from './MePageTabs';

const PageStatisticsTab = () => (
  <div
    id={`${PAGE_STATISTICS_TAB}-panel`}
    role="tabpanel"
    aria-labelledby={`${PAGE_STATISTICS_TAB}-tab`}
    className="me-page-tab-panel"
  >
    <TotalScans />
    <UniqueUsers />
    <TotalUsersChart />
    <UniqueUsersChart />
    <ScansDaytime />
    <ScansLocation />
    <Devices />
  </div>
);

export default PageStatisticsTab;
